import { useState } from 'react';

import { useRequestAccessMutation } from '../../../features/user/useRequestAccessMutation';
import { useUserQuery } from '../../../features/user/useUserQuery';

export const useUpdatePackage = () => {
  const [isHookModalOpen, setIsHookModalOpen] = useState<boolean>(false);
  const userQuery = useUserQuery();
  const requestAccessMutation = useRequestAccessMutation();
  const user = userQuery.data;
  const onOpenModalAndSendContactUsRequest = () => {
    if (user) {
      void requestAccessMutation.mutate('extension');
    }

    setIsHookModalOpen(true);
  };

  return {
    isHookModalOpen,
    setIsHookModalOpen,
    onOpenModalAndSendContactUsRequest,
  };
};
